import {
    PICKUP_DETAIL_CLOSE_NOTIFICATION,
    PICKUP_DETAIL_CLOSE_SAVE_NOTIFICATION,
    PICKUP_DETAIL_FORM_VALUE_CHANGE,
    PICKUP_DETAIL_OPEN_NOTIFICATION,
    SAVE_PICKUP_DETAIL_REQUEST_FAILED,
    SAVE_PICKUP_DETAIL_REQUEST_STARTED,
    SAVE_PICKUP_DETAIL_REQUEST_SUCCESS,
    VIEW_INVOICE_DETAIL_ADD_COMMENT,
    VIEW_INVOICE_DETAIL_ADD_LINE_IMAGE,
    VIEW_INVOICE_DETAIL_FAILED,
    VIEW_INVOICE_DETAIL_REMOVE_LINE_IMAGE,
    VIEW_INVOICE_DETAIL_REQUEST,
    VIEW_INVOICE_DETAIL_SUCCESS,
    VIEW_INVOICE_DETAIL_UPDATE_ALL_LINE_STATUS,
    VIEW_INVOICE_DETAIL_UPDATE_PICKUP_STATUS
} from "./InvoiceDetailConstants";
import {BASE_URL1} from "../../helpers/UrlHelper";


const initialState = {
    invoiceHeader: {},
    details: [],
    lineActions: [],
    isLoading: false,
    notification: {},
    setting: {},
    roles: [],
    formValues: {
        name: '',
        role: '',
        comment: '',
        signature: '',
    },
    saving: false,
    pickupSaveNotification: {
        show: false,
        success: false,
        message: '',
        url: '',
        canViewProofDocument:false
    }

}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case VIEW_INVOICE_DETAIL_REQUEST:
            return {
                ...state,
                isLoading: true,
                formValues: {
                    name: '',
                    role: '',
                    comment: '',
                    signature: ''
                }
            }
        case VIEW_INVOICE_DETAIL_SUCCESS:
            let tmpDetailLineActions = [];
            if (action.payload.details) {
                action.payload.details.forEach(detail => {
                    let newAction = {
                        id: detail.id,
                        pickup: detail.item !== "/C" && detail.item !== "/F" && !detail.alreadyAccepted,
                        comment: detail.comment,
                        supportingImage: detail.image,
                        showActionButtons: detail.item !== "/C" && detail.item !== "/F" && !detail.alreadyAccepted,
                        accepted: detail.alreadyAccepted
                    }
                    tmpDetailLineActions.push(newAction);
                })
            }
            let selectedRoleIndex = action.payload.setting.options.findIndex(option => option.isSelected);

            return {
                ...state,
                isLoading: false,
                invoiceHeader: action.payload.invoiceHeader,
                details: action.payload.details,
                lineActions: tmpDetailLineActions,
                setting: action.payload.setting,
                roles: action.payload.setting.options,
                formValues: {
                    ...state.formValues,
                    role: selectedRoleIndex !== -1 ? action.payload.setting.options[selectedRoleIndex].text : ''
                },
                notification: {
                    show: false,
                    type: '',
                    message: ''
                }
            }

        case VIEW_INVOICE_DETAIL_FAILED:
            return {
                ...state,
                isLoading: false,
                invoices: {},
                notification: {
                    show: true,
                    type: 'error',
                    message: action.payload
                }
            }

        case VIEW_INVOICE_DETAIL_ADD_COMMENT:
            return {
                ...state,
                lineActions: state.lineActions.map(lineAction => {
                    if (lineAction.id === action.payload.id) {
                        return {
                            ...lineAction,
                            comment: action.payload.comment
                        }
                    }
                    return lineAction
                })
            }
        case VIEW_INVOICE_DETAIL_ADD_LINE_IMAGE:
            return {
                ...state,
                lineActions: state.lineActions.map(lineAction => {
                    if (lineAction.id === action.payload.id) {
                        return {
                            ...lineAction,
                            supportingImage: action.payload.image
                        }
                    }
                    return lineAction
                })
            }

        case VIEW_INVOICE_DETAIL_REMOVE_LINE_IMAGE:
            return {
                ...state,
                lineActions: state.lineActions.map(lineAction => {
                    if (lineAction.id === action.payload.id) {
                        return {
                            ...lineAction,
                            supportingImage: ''
                        }
                    }
                    return lineAction
                })
            }

        case VIEW_INVOICE_DETAIL_UPDATE_PICKUP_STATUS:
            return {
                ...state,
                lineActions: state.lineActions.map(lineAction => {
                    if (lineAction.id === action.payload.id) {
                        return {
                            ...lineAction,
                            pickup: action.payload.status
                        }
                    }
                    return lineAction
                })
            }

        case VIEW_INVOICE_DETAIL_UPDATE_ALL_LINE_STATUS:
            return {
                ...state,
                lineActions: state.lineActions.map(lineAction => {
                    if (lineAction.showActionButtons) {
                        return {
                            ...lineAction,
                            pickup: action.payload.checkedStatus
                        }
                    }
                    return lineAction
                })
            }
        case SAVE_PICKUP_DETAIL_REQUEST_STARTED:
            return {
                ...state,
                saving: true,
                notification: {
                    ...state.notification,
                    show: false
                }
            }

        case SAVE_PICKUP_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                saving: false,
                pickupSaveNotification: {
                    show: true,
                    success: true,
                    message: action.payload.message,
                    canViewProofDocument: action.payload.canViewProofDocument,
                    url: action.payload.canViewProofDocument ?  `${BASE_URL1}${action.payload.url}` : "",
                }

            }
        case SAVE_PICKUP_DETAIL_REQUEST_FAILED:
            return {
                ...state,
                saving: false,
                pickupSaveNotification: {
                    ...state.pickupSaveNotification,
                    show: true,
                    success: false,
                    message: action.payload,
                }
            }

        case PICKUP_DETAIL_CLOSE_NOTIFICATION:
            return {
                ...state,
                notification: {
                    ...state.notification,
                    show: false,
                    message: ''
                }
            }

        case PICKUP_DETAIL_OPEN_NOTIFICATION:
            return {
                ...state,
                notification: {
                    ...state.notification,
                    show: true,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }

        case PICKUP_DETAIL_FORM_VALUE_CHANGE:
            return {
                ...state,
                formValues: {
                    ...state.formValues,
                    [action.payload.name]: action.payload.value
                }
            }
        case PICKUP_DETAIL_CLOSE_SAVE_NOTIFICATION:
            return {
                ...state,
                pickupSaveNotification: {
                    ...state.pickupSaveNotification,
                    show: false,
                    message: '',

                }
            }
        default:
            return state

    }
}

export default reducer;
